/*
 * Public API Surface of mango-login
 */

export * from './lib/mango-login.service';
export * from './lib/mango-login.component';
export * from './lib/mango-login.module';
export * from './lib/auth/auth.module';
export * from './lib/components/landing/landing.component';
export * from './lib/auth/login/login.component';
export * from './lib/auth/registration/registration.component';
export * from './lib/auth/forgot-password/forgot-password.component';
export * from './lib/services/auth-service/auth.service';
export * from './lib/services/dataLogin/data-login.service';
export * from './lib/interfaces/roles.interface';
export * from './lib/services/config-service/config.service';
export * from './lib/services/mango-events-analytics/mango-events-analytics.service';